module.exports = __webpack_public_path__ + "static/media/carousel5.3f837e43.jpg";